<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
  <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp">
          <div class="kvp__k">Subject:</div>
          <div class="kvp__v">{{ timelineSection.subject }} &nbsp;</div>
        </div>
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp">
          <div class="kvp__k">Attendance:</div>
          <div class="kvp__v">{{ timelineSection.attendance }} &nbsp;</div>
        </div>
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp">
          <div class="kvp__k">Time:</div>
          <div class="kvp__v">{{ timelineSection.startTime }} - {{ timelineSection.endTime }} &nbsp;</div>
        </div>
      </div>
    </div>
  </div>
  @if (metricsVisible) {
    <div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        @if (hasData) {
          <div>
            <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4 auto-fit">
              <div class="tw:flex-1 tw:px-[15px]">
                <div class="kvp">
                  <div class="kvp__k slider-k">Engagement:</div>
                  <div class="kvp__v slider-v">
                    <scale-rater [value]="timelineSection.engagement"
                      [disabled]="true">
                    </scale-rater>
                  </div>
                </div>
              </div>
            </div>
            <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4 auto-fit">
              <div class="tw:flex-1 tw:px-[15px]">
                <div class="kvp">
                  <div class="kvp__k slider-k">Comprehension:</div>
                  <div class="kvp__v slider-v">
                    <scale-rater [value]="timelineSection.comprehension"
                      [disabled]="true">
                    </scale-rater>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (!hasData) {
          <div class="session__no-student-data">
            No learner metrics available
          </div>
        }
      </div>
    </div>
  }
</div>

@if (metricsVisible) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Lesson Objectives:</div>
          <div class="kvp__v kvp__v--long-text">
            {{ timelineSection.lessonSummary }}
          </div>
        </div>
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Learner Comments:</div>
          <div class="kvp__v kvp__v--long-text">
            {{ timelineSection.learnerComments }}
          </div>
        </div>
      </div>
    </div>
  </div>
}
